module.exports = __webpack_public_path__ + "img/6bcd81e.jpg";